const addToSelector = document.querySelector('.tribe-events-calendar-list__add-to');
const dropdownBtn = addToSelector.querySelector('.tribe-events-c-subscribe-dropdown__button');
const dropdown = addToSelector.querySelector('.tribe-events-c-subscribe-dropdown__content');

const addToCalendarBtn = () => {
    if (addToSelector) {
        
        dropdownBtn.addEventListener('click', function () {
            if (!dropdownBtn.classList.contains('active')) {
                dropdownBtn.classList.add('active');
                dropdown.classList.add('active-dropdown');
            } else {
                dropdownBtn.classList.remove('active');
                dropdown.classList.remove('active-dropdown');
            }
        });

        document.body.addEventListener('click', (e) => {
            if (e.target !== dropdownBtn && e.target.offsetParent !== dropdownBtn && dropdownBtn.classList.contains('active')) {
                dropdownBtn.classList.remove('active');
                dropdown.classList.remove('active-dropdown');
            }
        });
    }
};


const controller = {
	init() {
        addToCalendarBtn();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
